<template>
  <div class="MemberProfile">   
    <v-row>
      <v-col cols="12" md="6" sm="12">
    <v-btn class="red" block large dark v-if="member && !loading"  @click="changePassword()">
      <v-icon class="mr-2">mdi-key</v-icon>
      Change Password
      </v-btn>
      </v-col>
    </v-row>
     <InfoCard :loading="loading"  v-if="member" :member.sync="member" @edit="editMemberTrigger($event)"/>
    <EditMember
      :popup="editMemberModal"
      @modalStatus="changeEditModalStatus($event)"
      @successEdit="successEdit"
      :member="member"
      :loading="loading"
      v-if="member"
    />
    <PasswordReset
    :popup="passwordChange"
     @modalStatus="changePasswordModalStatus($event)"
     @successReset="successReset"
     />

    <Snackbars :text="succesMsg" :snackbar="snackbar" @classSnackbar="clossSnackbar"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");


import InfoCard from "@/components/profile/InfoCard";
import EditMember from "@/components/profile/Edit";
import PasswordReset from "@/components/profile/PasswordReset";
import Snackbars from "@/components/shared/Snackbars";

export default {
  name: "MemberProfile",
  components: {
    EditMember,
    Snackbars,
    InfoCard,
    PasswordReset
  },
  data: () => ({
    title: "Member Info",
    editMemberModal: false,
    snackbar: false,
    confirmOpen: false,
    succesMsg: "",
    selectedId: null,
    memberId: localStorage.getItem("user_id"),
    passwordChange:false
  }),
  mounted() {   
    this.$store.dispatch("auth/getProfile");
  },

  computed: {
    ...mapGetters({     
      loading: "loading",
      member: "profile"
    })
  },

  methods: {
    
    editMemberTrigger(value) {
      if (this.member != null) {
        this.editMemberModal = value;
      }
    },

    changeModalStatus(value) {
      this.memberModal = value;
    },
    clossSnackbar() {
      this.snackbar = false;
    },
    changeEditModalStatus(value) {    
      this.editMemberModal = value;      
    },

    setEditData(value) {
      this.editMemberModal = true;
      this.selectedId = value;
    },
    successEdit() {
      this.selectedId = null;
      this.$store.dispatch("auth/getProfile");
      this.succesMsg = "Profile successfully updated";
      this.snackbar = true;
      this.editMemberModal = false;
    },
    changePassword(){
      this.passwordChange = true;
    },
    changePasswordModalStatus(){
      this.passwordChange = ! this.passwordChange;
    },
     successReset() { 
      this.succesMsg = "Password successfully updated";
      this.snackbar = true;
      this.passwordChange = false;
    },
  }
};
</script>
